import { Box, Paper, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, } from "@mui/material";
const LGAmountAllocationTable = ({invoice, lgGroupedAllocation }) => {
  return (
    <Paper elevation={0} sx={{ border: "1px solid #b7cce3", borderRadius: "8px", pt: 1, px: 1, pb: 0, backgroundColor: "#edf3fa", }} >
      <Box display="flex" alignItems="center" gap={1} mb={1}>
        <Typography sx={{ fontSize: "15px", fontWeight: 800, color: "#1f3f68", }} > Grouped LG Amount Distribution </Typography>
      </Box>
      <TableContainer sx={{  overflowY: "auto", overflowX: "hidden", }} >
        <Table size="small" stickyHeader sx={{ tableLayout: "fixed", width: "100%", backgroundColor: "#edf3fa", "& .MuiTableRow-root:last-child td": { borderBottom: "none", }, "& .MuiTableCell-root": { backgroundColor: "#edf3fa", } }} >
          <TableHead>
            <TableRow sx={{ backgroundColor: "#dbe8f5", }} >
              <TableCell align="left" size="small" sx={headCell}>LG ASSEMBLY</TableCell>
              <TableCell align="left" size="small" sx={headCell}>ALLOCATION %</TableCell>
              <TableCell align="left" size="small" sx={headCell}>CALCULATED AMOUNT ({invoice?.currency?.name || ""})</TableCell>
              <TableCell size="small" sx={headCell}>NOTE</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {lgGroupedAllocation?.length > 0 &&lgGroupedAllocation?.map((row, index) =>  (
                <TableRow key={row.id} sx={{ backgroundColor: index === 0 ? "#f5f7fa" : "transparent", }} >
                  <TableCell sx={bodyCellBold}>{row.asset_name}</TableCell>
                  <TableCell sx={bodyCell}>{row.percentage}%</TableCell>
                  <TableCell sx={{ ...bodyCellBold, color: "#1f3f68", }} > {`${invoice?.currency?.symbol|| ""}${row.display_amount|| ""}`} </TableCell>
                  <TableCell sx={{ ...bodyCell, color: "#62779a", }} > {row.note} </TableCell>
                </TableRow>
              )
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
}

const headCell = {
  fontSize: "14px",
  fontWeight: 700,
  color: "#1e3b67",
  backgroundColor: "#d8e6f5 !important",
  borderBottom: "1px solid #c6d7ea",
  pl: 1.2,
};
const bodyCell = {
  color: "#2f3b52",
  borderBottom: "1px solid #d6e2f0",
  backgroundColor: "#edf3fa",
  fontSize: "14px",
};
const bodyCellBold = {
  ...bodyCell,
  fontWeight: 700,
  color: "#24364d",
};

export default LGAmountAllocationTable